const BASE_URL = process.env.RAZZLE_CLIENT_URI;

if (!BASE_URL) {
    throw new Error('graphql url must be set');
}

export const uploadCandidateAsset = () => BASE_URL.replace('api', 'uploadCandidateAsset');
